import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
    PlanCard,
    HiddenRadio,
    MainColumn,
    LabelPricing,
    PlanHeaderRow,
    PlanName,
    PlanPrice,
    PlanOriginalPrice,
    PlanPricePlaceholder,
    PlanTagline,
    PlanDescription,
    MostPopularBadge,
    IncludedBlock,
    IncludedRow,
    CheckmarkIconSlot,
    IncludedText,
} from './PearlConnectPlanTile.styled';
import { PearlConnectPlanCheckmark } from './PearlConnectPlanCheckmark';

const PearlConnectPlanTile = ({
    title,
    priceLabel,
    originalPriceLabel,
    tagline,
    description,
    benefits,
    planId,
    planTier,
    formFieldName,
    isSelected,
    onSelect,
    isMostPopular = false,
    isPriceLoading = false,
}) => {
    const { register, setValue } = useFormContext();
    const { t } = useTranslation();

    const handleSelect = () => {
        setValue(formFieldName, planTier);
        onSelect();
    };

    const handleCardKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSelect();
        }
    };

    return (
        <PlanCard
            data-testid={planTier}
            $isSelected={isSelected}
            $isPopularTier={isMostPopular}
            tabIndex={0}
            onClick={handleSelect}
            onKeyDown={handleCardKeyDown}
        >
            <HiddenRadio
                type="radio"
                id={String(planId)}
                value={planTier}
                defaultChecked={isSelected}
                readOnly
                {...register(formFieldName)}
            />
            <MainColumn>
                <LabelPricing>
                    <PlanHeaderRow>
                        <PlanName>{title}</PlanName>
                        {isMostPopular ? (
                            <MostPopularBadge>
                                {t('Forms.PlanTier.MostPopularBadge')}
                            </MostPopularBadge>
                        ) : null}
                    </PlanHeaderRow>
                    <PlanPrice data-testid={`${planTier}-price`} aria-busy={isPriceLoading}>
                        {isPriceLoading ? (
                            <PlanPricePlaceholder data-testid={`${planTier}-price-loading`} />
                        ) : (
                            <>
                                {originalPriceLabel ? (
                                    <>
                                        <PlanOriginalPrice>{originalPriceLabel}</PlanOriginalPrice>{' '}
                                    </>
                                ) : null}
                                {priceLabel}
                            </>
                        )}
                    </PlanPrice>
                    {tagline ? (
                        <PlanTagline $pearlPink={isMostPopular}>{tagline}</PlanTagline>
                    ) : null}
                    {description ? <PlanDescription>{description}</PlanDescription> : null}
                </LabelPricing>
                {benefits?.length > 0 && (
                    <IncludedBlock>
                        {benefits.map((line, index) => (
                            <IncludedRow key={`${planTier}-b-${index}`}>
                                <CheckmarkIconSlot>
                                    <PearlConnectPlanCheckmark />
                                </CheckmarkIconSlot>
                                <IncludedText>{line}</IncludedText>
                            </IncludedRow>
                        ))}
                    </IncludedBlock>
                )}
            </MainColumn>
        </PlanCard>
    );
};

export default PearlConnectPlanTile;
